export default "__VITE_ASSET__CM23_uy7__"